import React, { useState, useRef, useEffect } from 'react';
import { Home, List, Users, Plus, Menu, X, Search, Filter, Settings, BarChart3 } from 'lucide-react';
import './MobileNavigation.css';

export default function MobileNavigation({ 
  currentScreen, 
  onScreenChange, 
  onAddActivity, 
  onShowSearch,
  onShowFilter,
  currentUser,
  onShowProfile,
  onShowProgress
}) {
  const [showQuickActions, setShowQuickActions] = useState(false);
  const quickActionsRef = useRef(null);

  // Close quick actions when clicking outside
  useEffect(() => {
    if (!showQuickActions) return;
    
    const handleClick = (e) => {
      if (quickActionsRef.current && !quickActionsRef.current.contains(e.target)) {
        setShowQuickActions(false);
      }
    };
    
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('touchstart', handleClick);
    
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('touchstart', handleClick);
    };
  }, [showQuickActions]);

  const handleQuickActionPress = (action) => {
    action();
    setShowQuickActions(false);
  };

  const quickActions = [
    { icon: Plus, label: 'Add Activity', action: onAddActivity, color: 'accent' },
    { icon: Search, label: 'Search', action: onShowSearch, color: 'secondary' },
    { icon: Filter, label: 'Filter', action: onShowFilter, color: 'secondary' },
    { icon: BarChart3, label: 'Progress', action: onShowProgress, color: 'secondary' },
    { icon: Settings, label: 'Profile', action: onShowProfile, color: 'secondary' },
  ];

  return (
    <>
      {/* Mobile Bottom Navigation */}
      <nav className="mobile-nav" role="navigation" aria-label="Main navigation">
        <button
          className={`mobile-nav-item ${currentScreen === 'overview' ? 'active' : ''}`}
          onClick={() => onScreenChange('overview')}
          aria-label="Overview"
          aria-current={currentScreen === 'overview' ? 'page' : undefined}
        >
          <Home size={20} />
          <span>Overview</span>
        </button>
        
        <button
          className={`mobile-nav-item ${currentScreen === 'chores' ? 'active' : ''}`}
          onClick={() => onScreenChange('chores')}
          aria-label="Chores"
          aria-current={currentScreen === 'chores' ? 'page' : undefined}
        >
          <List size={20} />
          <span>Chores</span>
        </button>
        
        {currentUser?.role === 'admin' && (
          <button
            className={`mobile-nav-item ${currentScreen === 'users' ? 'active' : ''}`}
            onClick={() => onScreenChange('users')}
            aria-label="Users"
            aria-current={currentScreen === 'users' ? 'page' : undefined}
          >
            <Users size={20} />
            <span>Users</span>
          </button>
        )}
        
        {/* Quick Actions Button */}
        <div className="mobile-nav-quick-actions" ref={quickActionsRef}>
          <button
            className={`mobile-nav-quick-btn ${showQuickActions ? 'active' : ''}`}
            onClick={() => setShowQuickActions(!showQuickActions)}
            aria-label="Quick actions"
            aria-expanded={showQuickActions}
          >
            {showQuickActions ? <X size={20} /> : <Plus size={20} />}
            <span>Actions</span>
          </button>
          
          {/* Quick Actions Menu */}
          {showQuickActions && (
            <div className="mobile-quick-actions-menu">
              {quickActions.map((action, index) => (
                <button
                  key={index}
                  className={`mobile-quick-action-btn mobile-quick-action-${action.color}`}
                  onClick={() => handleQuickActionPress(action.action)}
                  aria-label={action.label}
                >
                  <action.icon size={18} />
                  <span>{action.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
